

const LoginUserInfoKey = "LoginUserInfoKey";
const LoginStateKey = "LoginStateKey";

const RedirectedFromIDPKey = "RedirectedFromIDPKey";

const CurrentActivePageKey = "CurrentActivePageKey";

const SiteSettingsDetailsKey = "SiteSettingsDetailsKey";
const DocumentPathKey = "DocumentPathKey";
const CaseNumberRegexKey = "CaseNumberRegexKey";
const NarrativeCharsLimitKey = "NarrativeCharsLimitKey";
const NotesCharsLimitKey = "NotesCharsLimitKey";


const IntegrationIDKey = "IntegrationIDKey";
const IntegrationInfoKey = "IntegrationInfoKey";
const UserLoginDetailsKey = "UserLoginDetailsKey";

const CaseInformationKey = "CaseInformationKey";
const BatchDocumentsKey = "BatchDocumentsKey";

const ClearSession = () => {
  try {
    // Clear all session storage
    sessionStorage.clear();
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - ClearSession", {});
  }
}

const ClearSessionValue = (sessionKey) => {
  try {
    if (sessionStorage.getItem(sessionKey)) {
      sessionStorage.removeItem(sessionKey);
    }
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - ClearSessionValue", {});
  }
};

const SetSession = (sessionKey, sessionValue) => {
  try {
    // Set session values
    sessionStorage.setItem(sessionKey, sessionValue);
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - SetSession", {});
  }
}

const GetValueFromSession = (sessionKey) => {
  try {
    const sessionValue = sessionStorage.getItem(sessionKey);
    return sessionValue;
  }
  catch (error) {
   //throw LoggerUtility.ProcessErrorData(error, "SessionManager - GetValueFromSession", {});
  }
}

const GetDataFromSession = (sessionKey) => {
  try {
    return JSON.parse(sessionStorage.getItem(sessionKey)) || [];
  }
  catch (error) {
   // throw LoggerUtility.ProcessErrorData(error, "SessionManager - GetDataFromSession", {});
  }
}

const GetDataFromSessionByValue = (comparisonValue, comparisonField, sessionKey) => {
  try {
    const existingSessionData = GetDataFromSession(sessionKey);

    if (existingSessionData.length > 0) {
      // Search for the record based on the dynamic comparison field
      const foundRecord = existingSessionData.find((item) => String(item[comparisonField]).toLowerCase() === String(comparisonValue).toLowerCase());
      return foundRecord || null;
    } else { return null; }
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - GetDataFromSessionByValue", {});
  }
}

// Around line 85-130 - Fix AddOrUpdateParent to handle arrays
const AddOrUpdateParent = (newResponse, comparisonField, sessionKey) => {
  try {
    const sessionData = GetDataFromSession(sessionKey);

    // console.log('🔍 AddOrUpdateParent Debug:', {
    //   sessionKey,
    //   comparisonField,
    //   'newResponse type': Array.isArray(newResponse) ? 'array' : typeof newResponse,
    //   'newResponse length': Array.isArray(newResponse) ? newResponse.length : 'not array',
    //   'newResponse': newResponse,
    //   'sessionData.length': sessionData.length
    // });

    // 🔍 FIXED: Handle both single object and array cases
    const itemsToProcess = Array.isArray(newResponse) ? newResponse : [newResponse];

    itemsToProcess.forEach((item, itemIndex) => {
      // console.log(`🔍 Processing item ${itemIndex}:`, {
      //   item,
      //   'item[comparisonField]': item[comparisonField]
      // });

      // Check if item has the comparison field
      // if (!item || item[comparisonField] === undefined || item[comparisonField] === null) {
      //   console.error(`🔍 ERROR: Item ${itemIndex} missing comparison field!`, {
      //     item,
      //     comparisonField,
      //     'available keys': item ? Object.keys(item) : 'none'
      //   });
      //   return; // Skip this item
      // }

      const existingParentIndex = sessionData.findIndex((existingItem) => 
        existingItem && 
        existingItem[comparisonField] !== undefined &&
        String(existingItem[comparisonField]).toLowerCase() === String(item[comparisonField]).toLowerCase()
      );

      //console.log(`🔍 Item ${itemIndex} existingParentIndex:`, existingParentIndex);

      if (existingParentIndex !== -1) {
        // Update existing item
        sessionData[existingParentIndex] = { ...sessionData[existingParentIndex], ...item };
        console.log(`🔍 Updated existing item at index ${existingParentIndex}`);
      } else {
        // Add new item
        sessionData.push(item);
        console.log(`🔍 Added new item. Total count: ${sessionData.length}`);
      }
    });

    // Save the updated sessionData
    sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
    console.log('🔍 Session updated successfully');

  }
  catch (error) {
    console.error("🔍 Error in AddOrUpdateParent:", error);
  }
};



// Function to set session data
const SetDataToSession = (newResponse, comparisonField, sessionKey) => {
  try {
    const sessionData = GetDataFromSession(sessionKey);

    newResponse.forEach(item => {
      const existingItem = sessionData.find(existing => String(existing[comparisonField]).toLowerCase() === String(item[comparisonField]).toLowerCase());

      if (!existingItem) {
        sessionData.push(item);
      } else {
        //existingItem.lastViewed = item.name; // Update logic here (if needed)
      }
    });

    // Store the updated array back to sessionStorage
    sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - SetDataToSession", {});
  }

};

const GetChildDataFromSessionByParentID = (comparisonValue, comparisonField, childFieldName, sessionKey) => {
  try {
    const existingSessionData = GetDataFromSession(sessionKey);

    if (existingSessionData.length > 0) {
      // Search for the record based on the dynamic comparison field
      const parent = existingSessionData.find((item) => String(item[comparisonField]).toLowerCase() === String(comparisonValue).toLowerCase());
      if (parent && parent[childFieldName]) {
        return parent[childFieldName];
      } else { return null; }
    } else { return null; }
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - GetChildDataFromSessionByParentID", {});
  }
}


// Add a child to a parent
const AddOrUpdateChildToParent = (comparisonField, parentValue, childFieldName, childComparisonField, childArray, sessionKey) => {
  try {
    const sessionData = GetDataFromSession(sessionKey);

    const parentIndex = sessionData.findIndex((item) => String(item[comparisonField]).toLowerCase() === String(parentValue).toLowerCase());


    if (parentIndex !== -1) {
      const updatedData = [...sessionData];
      const parent = updatedData[parentIndex];

      // Access the dynamic child array field or initialize it as an empty array
      const existingChildren = parent[childFieldName] || [];

      // Process each child in the provided array
      childArray.forEach((newChild) => {
        const existingChildIndex = existingChildren.findIndex(
          (child) => String(child[childComparisonField]).toLowerCase() === String(newChild[childComparisonField]).toLowerCase()
        );

        if (existingChildIndex !== -1) {
          // Update the existing child
          existingChildren[existingChildIndex] = { ...existingChildren[existingChildIndex], ...newChild };
        } else {
          // Add new child
          existingChildren.push(newChild);
        }
      });

      // Append new children to the parent
      parent[childFieldName] = existingChildren;
      updatedData[parentIndex] = parent;

      sessionStorage.setItem(sessionKey, JSON.stringify(updatedData));
    }
  }
  catch (error) {
    //throw LoggerUtility.ProcessErrorData(error, "SessionManager - AddOrUpdateChildToParent", {});
  }

};

// Delete a Parent Data from Session
const DeleteParentFromSession = (parentId, comparisonField, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parent = sessionData.find(item => String(item[comparisonField]).toLowerCase() === String(parentId)).toLowerCase();
  if (parent) {
    parent = parent.filter(item => String(item[comparisonField]).toLowerCase() !== String(parentId).toLowerCase());
  }

  sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
};


const AddChildToParent_03 = (comparisonField, parentValue, childFieldName, childComparisonField, childArray, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parentIndex = sessionData.findIndex((item) => item[comparisonField] === parentValue);


  if (parentIndex !== -1) {
    const updatedData = [...sessionData];
    const parent = updatedData[parentIndex];

    // Access the dynamic child array field or initialize it as an empty array
    const existingChildren = parent[childFieldName] || [];

    // Filter out duplicates and add new children
    const newChildren = childArray.filter(
      (child) => !existingChildren.some((existingChild) => existingChild[childComparisonField] === child[childComparisonField])
    );

    // Append new children to the parent
    parent[childFieldName] = [...existingChildren, ...newChildren];
    updatedData[parentIndex] = parent;

    sessionStorage.setItem(sessionKey, JSON.stringify(updatedData));
  }

};


// Add a child to a parent
const AddChildToParent_02 = (comparisonField, parentValue, childFieldName, childComparisonField, child, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parent = sessionData.find(existing => existing[comparisonField] === parentValue);
  if (parent) {
    parent[childFieldName] = parent[childFieldName] || []; // Initialize children array if not present   -- parent.children = parent.children || [];
    const existingChild = parent[childFieldName].find(existingChild =>
      existingChild[childComparisonField] === child[childComparisonField]
    );

    if (!existingChild) {
      parent[childFieldName].push(child);
    } else {
      console.warn("Child with the specified field already exists.");
    }
  } else {
    console.error(`Parent with ID ${parentValue} not found`);
  }

  sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
};

// Update a child item
const UpdateChildOfParent = (parentId, childId, updatedChild, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parent = sessionData.find(item => item.id === parentId);
  if (parent && parent.children) {
    const childIndex = parent.children.findIndex(child => child.id === childId);
    if (childIndex !== -1) {
      parent.children[childIndex] = { ...parent.children[childIndex], ...updatedChild };
    } else {
      console.error(`Child with ID ${childId} not found`);
    }
  } else {
    console.error(`Parent with ID ${parentId} not found or has no children`);
  }

  sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
};

// Delete a child from a parent
const DeleteChildFromParent = (parentId, childId, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parent = sessionData.find(item => item.id === parentId);
  if (parent && parent.children) {
    parent.children = parent.children.filter(child => child.id !== childId);
  } else {
    console.error(`Parent with ID ${parentId} not found or has no children`);
  }

  sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
};

// Search children with dynamic comparison
const SearchChildrenOfParent = (parentComparisonFields, parentCriteria, keyword, sessionKey) => {
  const sessionData = GetDataFromSession(sessionKey);

  const parent = sessionData.find(item =>
    parentComparisonFields.every(field => item[field] === parentCriteria[field])
  );

  if (parent && parent.children) {
    return parent.children.filter(child =>
      Object.values(child).some(value =>
        value.toString().toLowerCase().includes(keyword.toLowerCase())
      )
    );
  } else {
    console.error("Parent not found or has no children.");
    return [];
  }
};



const SessionManager = {
  LoginUserInfoKey,
  UserLoginDetailsKey,
  LoginStateKey,
  RedirectedFromIDPKey,
  CurrentActivePageKey,
  SiteSettingsDetailsKey,
  DocumentPathKey,
  CaseNumberRegexKey,
  NarrativeCharsLimitKey,
  NotesCharsLimitKey,
  IntegrationIDKey,
  IntegrationInfoKey,
  CaseInformationKey,
  BatchDocumentsKey,

  ClearSession,
  ClearSessionValue,
  SetSession,
  GetValueFromSession,

  AddOrUpdateParent,
  AddOrUpdateChildToParent,
  DeleteParentFromSession,

  GetDataFromSession,
  GetDataFromSessionByValue,
  GetChildDataFromSessionByParentID,

  SetDataToSession
};


export default SessionManager;